import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BrandAvatar } from 'src/legacy/components/UI/Avatars/BrandAvatar';

import { OnboardingFormCard } from '../OnboardingFormCard';
import {
  MfaFormProps,
  OnboardingForgotPasswordForm,
} from '../OnboardingForms/OnboardingForgotPasswordForm';

import { OnboardingAuthLayoutProps } from './OnboardingAuthLayout';

type OnboardingForgotPasswordPageProps = OnboardingAuthLayoutProps &
  MfaFormProps;

export const OnboardingForgotPasswordPage = ({
  onAuthComplete,
  onMfaRequired,
}: OnboardingForgotPasswordPageProps) => (
  <OnboardingFormCard>
    <BrandAvatar />
    <div className="mt-3 mb-10 text-center px-4 sm:px-0">
      <BaseTypography fontType="18Medium">Reset your password</BaseTypography>
    </div>
    <div className="-mt-5">
      <OnboardingForgotPasswordForm
        onAuthComplete={onAuthComplete}
        onMfaRequired={onMfaRequired}
      />
    </div>
  </OnboardingFormCard>
);
